import { render, staticRenderFns } from "./AddAdress.vue?vue&type=template&id=49fc9069&scoped=true&"
import script from "./AddAdress.vue?vue&type=script&lang=js&"
export * from "./AddAdress.vue?vue&type=script&lang=js&"
import style0 from "./AddAdress.vue?vue&type=style&index=0&id=49fc9069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc9069",
  null
  
)

export default component.exports